import React, { useState, useEffect } from "react";
import "./recentSales.css";
import CardFilter from "../card/CardFilter";
import RecentSalesTable from "./RecentSalesTable";
import api from "../../api/config";

const RecentSales = () => {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("Today");
  const handleFilterChange = (filter) => {
    setFilter(filter);
  };

  // const fetchData = async () => {
  //   await fetch("http://localhost:4500/recentsales")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       setItems(data);
  //     })
  //     .catch((e) => console.log(e.message));
  // };

  const fetchData = async () => {
    try {
      const response = await api.get("/recentsales", {
        headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
      });
      setItems(response.data.data);
    } catch (err) {
      console.error(`Error:${err.message}`);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="card recent-sales overflow-auto">
      <CardFilter filterChange={handleFilterChange} />
      <div className="card-body">
        <h5 className="card-title">
          Recent Sales <span>| {filter}</span>
        </h5>
        {/* {showChild && <RecentSalesTable items={items} />} */}
        <RecentSalesTable items={items} />
      </div>
    </div>
  );
};

export default RecentSales;
